module.exports = __webpack_public_path__ + "media/GoldMiniPartnerBadge.static.0894c200c537981aeb43832c072559e5.svg";